/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
import { base } from '@/base/base'
import { WebDefine } from '@/defines/WebDefine'
import { log } from '@/utils/functions'
import { md5 } from '@/utils/md5'

export enum WebServerType {
  PHP = 'PHP',
  WEB = 'WEB',
  PAY = 'PAY',
}

interface FetchWithRetryOptions extends RequestInit {
  retryCount?: number
  retryDelay?: number // 毫秒
}

export class HttpUtil {
  phpUrl: string
  payUrl: string
  webUrl: string

  constructor() {
    if (globalThis.webInfo) {
      if (globalThis.webInfo?.bTest) {
        base.publish = false
      } else {
        base.publish = true
      }
    }

    if (globalThis.webInfo?.cid) {
      base.channelId = globalThis.webInfo?.cid
    }

    // if (base.publish) {
    //   this.phpUrl = WebDefine.PHP_URL
    //   this.payUrl = WebDefine.PAY_URL
    //   this.webUrl = WebDefine.WEB_URL
    // } else {
    //   this.phpUrl = WebDefine.PHP_TEST_URL
    //   this.payUrl = WebDefine.PAY_TEST_URL
    //   this.webUrl = WebDefine.WEB_TEST_URL
    // }

    // this.phpUrl = WebDefine.PHP_TEST_URL
    // this.payUrl = WebDefine.PAY_TEST_URL
    // this.webUrl = WebDefine.WEB_TEST_URL

    this.phpUrl = WebDefine.PHP_URL
    this.payUrl = WebDefine.PAY_URL
    this.webUrl = WebDefine.WEB_URL
  }

  // http post json 请求，使用方式参考 test_()
  async postJson(
    route: WebDefine,
    data: any,
    webServerType: WebServerType = WebServerType.PHP,
    options: FetchWithRetryOptions = {},
  ) {
    const url = this.getFullUrl(route, webServerType)
    // log(`HttpUtil.postJson ${url}, ${webServerType}, ${new Date()}`, data, options);

    const signStr = this.generateRequestSignature(data)
    // log(`HttpUtil.postJson ${url}, sign = ${signStr}`);
    data['sign'] = signStr

    log(`HttpUtil.postJson ${url}, ${webServerType}, ${new Date()}`, JSON.stringify(data))

    const { retryCount = 1, retryDelay = 1000, ...fetchOptions } = options
    let lastError: Error | null = null

    for (let attempt = 0; attempt <= retryCount; attempt++) {
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...fetchOptions.headers,
          },
          body: JSON.stringify(data),
          ...fetchOptions,
        })

        if (!response.ok) {
          log(`HttpUtil.postJson ${url} error status: ${response.status}`)
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const resData = response.json()
        log(`HttpUtil.postJson ${url} success, ${new Date()}`, resData)
        return await resData
      } catch (error) {
        lastError = error as Error

        if (attempt < retryCount) {
          const delay = retryDelay * Math.pow(2, attempt)
          log(
            `HttpUtil.postJson ${url} warning request failed, ${delay}ms after, retry ${attempt + 1} ...`,
            error,
          )
          await new Promise((resolve) => setTimeout(resolve, delay))
        }
      }
    }

    log(`HttpUtil.postJson ${url} error The request failed and the number of retries was exhausted`)
    throw lastError || new Error('The request failed and the number of retries was exhausted')
  }

  getFullUrl(route: WebDefine, webServerType: WebServerType): string {
    const _key = this.getEnumKeyByValue(WebDefine, route)

    if (!base.publish) {
      // 测试服
      // if (WebDefineTest[key]) {
      //   route = WebDefineTest[key]
      // }
    }

    let url = ''
    if (route.startsWith('http') || route.startsWith('https')) {
      url = route
    } else {
      if (webServerType == WebServerType.PHP) {
        url = this.phpUrl + route
      } else if (webServerType == WebServerType.WEB) {
        url = this.webUrl + route
      } else if (webServerType == WebServerType.PAY) {
        url = this.payUrl + route
      }
    }

    return url
  }

  // 通过枚举的值获取枚举的键
  getEnumKeyByValue<T extends Record<string, string>>(
    enumObj: T,
    value: string,
  ): keyof T | undefined {
    return (Object.keys(enumObj) as Array<keyof T>).find((key) => enumObj[key] === value)
  }

  generateRequestSignature(data: object): string {
    // 1. 过滤掉值为undefined或null的字段
    const filteredData = {}
    for (const key in data) {
      if (data[key] !== undefined && data[key] !== null) {
        filteredData[key] = data[key]
      }
    }

    // 2. 获取所有键并按字典序排序
    const sortedKeys = Object.keys(filteredData).sort()

    // 3. 拼接键值对字符串
    const keyValuePairs = sortedKeys.map((key) => {
      // 将值转为字符串，如果是对象则转为JSON字符串
      const value =
        typeof filteredData[key] === 'object'
          ? JSON.stringify(filteredData[key])
          : String(filteredData[key])
      return `${key}=${value}`
    })
    keyValuePairs.push(`key=game2025`)

    const concatenatedString = keyValuePairs.join('&')
    // log(`HttpUtil.generateRequestSignature ${concatenatedString}`);

    // 4. 计算MD5哈希
    const md5Str = md5(concatenatedString)
    return md5Str
  }

  test_() {
    // let data = {
    //     c: 1,
    //     u: 10086,
    //     v: "1.0",
    // }

    // // 基本使用
    // this.postJson(WebDefine.blockConfig, data)
    //     .then(response => log('成功:', response))
    //     .catch(error => log('最终失败:', error));

    // // 自定义重试次数和延迟
    // this.postJson(WebDefine.testErrorUrl, data, WebServerType.PHP,
    //     {
    //         retryCount: 5,
    //         retryDelay: 2000,
    //         headers: {
    //             'Authorization': 'Bearer token'
    //         }
    //     }
    // )
    //     .then(response => {
    //         log('成功:', response)
    //     })
    //     .catch(error => {
    //         log('最终失败:', error)
    //     });

    // test go
    const data = {
      uid: 100486,
      name: 'admin',
    }
    this.postJson(WebDefine.users, data, WebServerType.PHP, {
      retryCount: 5,
      retryDelay: 2000,
    })
      .then((response) => {
        log('成功:', response)
      })
      .catch((error) => {
        log('最终失败:', error)
      })
  }
}
